import React from 'react';
import { cn } from '../../lib/utils';

const tones = {
  default: {
    word: 'text-[#1A1A1A]',
    dot: 'text-[#9F1D35]',
  },
  inverse: {
    word: 'text-[#FAFAF7]',
    dot: 'text-[#C9A961]',
  },
};

const sizes = {
  sm: {
    mark: 'h-8 w-8',
    text: 'text-[27px]',
    gap: 'gap-2.5',
  },
  md: {
    mark: 'h-10 w-10',
    text: 'text-[34px]',
    gap: 'gap-3',
  },
  lg: {
    mark: 'h-12 w-12',
    text: 'text-[38px]',
    gap: 'gap-3.5',
  },
};

const LogoLockup = ({ variant = 'default', size = 'md', className, markClassName, textClassName }) => {
  const tone = tones[variant] || tones.default;
  const scale = sizes[size] || sizes.md;

  return (
    <span className={cn('inline-flex items-center', scale.gap, className)}>
      <img
        src="/assets/magnolia-mark.png"
        alt=""
        aria-hidden="true"
        className={cn('shrink-0 object-contain', scale.mark, markClassName)}
      />
      <span
        className={cn(
          'font-serif font-medium leading-none tracking-normal',
          scale.text,
          tone.word,
          textClassName
        )}
      >
        magnolia<span className={tone.dot}>.</span>
      </span>
      <span className="sr-only">Magnolia</span>
    </span>
  );
};

export default LogoLockup;
